import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import Button from 'material-ui/Button'
import QRCode from 'qrcode.react'

import { setStage } from 'modules/users/otp'
import jsonSelector from 'selectors/json'

const Enable2FAStage1 = ({ setStage, open, secrets: { uri, label, secret } }) => (
  <Dialog open={open} onClose={() => setStage('')}>
    <DialogTitle>Get codes using Google Authenticator app</DialogTitle>
    <DialogContent>
      <ul className="ul-padding-left-small">
        <li>
          Download app from{' '}
          <a href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8">
            AppStore
          </a>{' '}
          (iOS) or{' '}
          <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">
            Google Play
          </a>{' '}
          (Android).
        </li>
        <li>
          Open application and select <b>Configure account</b>.
        </li>
        <li>
          Click <b>Scan Barcode</b>.
        </li>
      </ul>
      <div id="enable2fa-stage1-qr-code" className="box quare-code modal-qr">
        {uri && <QRCode value={uri} level="H" size={195} />}
      </div>
      <p className="text-justify">
        Can't scan the code? Add the entry manually, provide the following details to the
        application on your phone.
      </p>
      <p className="without-bottom-margin">
        — <b>Account</b>: <span id="enable2fa-stage1-account-name">{label}</span>
      </p>
      <p className="without-bottom-margin">
        — <b>Key</b>: <span id="enable2fa-stage1-key">{secret}</span>
      </p>
      <p className="without-bottom-margin">
        — <b>Time based</b>: <span>yes</span>
      </p>
    </DialogContent>
    <Divider light />
    <DialogActions>
      <Button onClick={() => setStage('')}>Close</Button>
      <Button id="btn-enable2fa-stage1-next" onClick={() => setStage('enable2fa_stage2')}>
        Next
      </Button>
    </DialogActions>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.users.otp.stage === 'enable2fa_stage1',
  secrets: jsonSelector('users.otp')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ setStage }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Enable2FAStage1)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/enable2fa_stage1.js